// Design icons for the SmartVitals check flow (rewamp/0. SMART VITALS NEW).
// Most tile icons already include their own rounded background — render them as-is.

// Screen 1 — details & choose flow
import editIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 1/edit icon.svg';
import lastReportIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 1/last report.svg';
import mentalWellnessIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 1/mental welness.svg';
import timeIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 1/time.svg';
import faceScanIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 1/vitals face scan.svg';
import completePictureIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 1/want complete picture.svg';

// Screen 3 — wellness questions
import checkIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 3 (question)/check.svg';
import q1Icon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 3 (question)/question 1.svg';
import q2Icon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 3 (question)/question 2.svg';
import q3Icon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 3 (question)/question 3.svg';
import q4Icon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 3 (question)/question 4.svg';
import q5Icon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 3 (question)/question 5.svg';
import q6Icon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 3 (question)/question 6.svg';
import q7Icon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 3 (question)/question 7.svg';
import q8Icon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 3 (question)/question 8.svg';
import level1Icon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 3 (question)/never.svg';
import level2Icon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 3 (question)/rarely.svg';
import level3Icon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 3 (question)/some times.svg';
import level4Icon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 3 (question)/often.svg';
import level5Icon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/screen 3 (question)/very frequently.svg';

// Face scan screen
import heartRateIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/face scan screen/heart rate.svg';
import oxygenIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/face scan screen/oxygen level.svg';
import hrvIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/face scan screen/heart rate variability.svg';
import bloodPressureIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/face scan screen/blood pressure.svg';
import haemoglobinIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/face scan screen/haemoglobin.svg';
import stressIndexIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/face scan screen/stress index.svg';
import breatheIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/face scan screen/breathe normally.svg';
import keepStillIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/face scan screen/keep still.svg';
import tipCardIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/face scan screen/green card notification.svg';
import goodLightingIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/face scan screen/good lighting.svg';
import faceCenteredIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/face scan screen/face centered.svg';
import neutralExpIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/face scan screen/neutral exp.svg';
import noMovementIcon from '../../Assets/Images/rewamp/0. SMART VITALS NEW/face scan screen/no movement.svg';

export const screen1Icons = {
  edit: editIcon,
  lastReport: lastReportIcon,
  mentalWellness: mentalWellnessIcon,
  time: timeIcon,
  faceScan: faceScanIcon,
  completePicture: completePictureIcon,
};

export const quizIcons = {
  check: checkIcon,
  questions: [q1Icon, q2Icon, q3Icon, q4Icon, q5Icon, q6Icon, q7Icon, q8Icon],
  // index 0 (feeling good) → 4 (needs care)
  levels: [level1Icon, level2Icon, level3Icon, level4Icon, level5Icon],
};

export const scanIcons = {
  heartRate: heartRateIcon,
  oxygen: oxygenIcon,
  hrv: hrvIcon,
  bloodPressure: bloodPressureIcon,
  haemoglobin: haemoglobinIcon,
  stressIndex: stressIndexIcon,
  breathe: breatheIcon,
  keepStill: keepStillIcon,
  time: timeIcon,
  tipCard: tipCardIcon,
  goodLighting: goodLightingIcon,
  faceCentered: faceCenteredIcon,
  neutralExp: neutralExpIcon,
  noMovement: noMovementIcon,
};
